import { withSearch } from '@elastic/react-search-ui';
import YearRangeFilters from '../../../components/filter/YearRangeFilter';

function NHLEHistoricPeriodDateRangeFilter({
  addFilter,
  setFilter,
  removeFilter,
  filters,
}) {
  return (
    <YearRangeFilters
      addFilter={addFilter}
      filters={filters}
      formHint="For example, 2007 AD"
      fromFieldId="periodDateMin"
      id="historical-date-range"
      label="Date range"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="periodDateMax"
    />
  );
}

export default withSearch(
  ({ addFilter, removeFilter, setFilter, filters }) => ({
    addFilter,
    setFilter,
    removeFilter,
    filters,
  }),
)(NHLEHistoricPeriodDateRangeFilter);
